import type { ReactNode } from 'react'
import BigQueryIcon from '~/components/illustration/databases/bigquery.svg?react'
import ClickhouseIcon from '~/components/illustration/databases/clickhouse.svg?react'
import DatabricksIcon from '~/components/illustration/databases/databricks.svg?react'
import DbtIcon from '~/components/illustration/databases/dbt.svg?react'
import GitIcon from '~/components/illustration/databases/git.svg?react'
import MCPServerIcon from '~/components/illustration/databases/mcp-server.svg?react'
import MicrosoftSQLServerIcon from '~/components/illustration/databases/sql-server.svg?react'
import MotherDuckIcon from '~/components/illustration/databases/motherduck.svg?react'
import MysqlIcon from '~/components/illustration/databases/mysql.svg?react'
import PostgresIcon from '~/components/illustration/databases/postgres.svg?react'
import RedshiftIcon from '~/components/illustration/databases/redshift.svg?react'
import SnowFlakeIcon from '~/components/illustration/databases/snowflake.svg?react'
import TrinoIcon from '~/components/illustration/databases/trino.svg?react'

export type IntegrationItemProps = {
  name: string
  icon: ReactNode
  link: string
}

const AmazonRedshift: IntegrationItemProps = {
  name: 'Amazon Redshift',
  icon: <RedshiftIcon />,
  link: 'https://docs.omni.co/connect-data/setup/redshift/',
}

const GoogleBigQuery: IntegrationItemProps = {
  name: 'Google BigQuery',
  icon: <BigQueryIcon />,
  link: 'https://docs.omni.co/connect-data/setup/bigquery/',
}

const Snowflake: IntegrationItemProps = {
  name: 'Snowflake',
  icon: <SnowFlakeIcon />,
  link: 'https://docs.omni.co/connect-data/setup/snowflake/',
}

const Databricks: IntegrationItemProps = {
  name: 'Databricks',
  icon: <DatabricksIcon />,
  link: 'https://docs.omni.co/connect-data/setup/databricks/',
}

const MySQL: IntegrationItemProps = {
  name: 'MySQL',
  icon: <MysqlIcon />,
  link: 'https://docs.omni.co/connect-data/setup/mysql/',
}

const MotherDuck: IntegrationItemProps = {
  name: 'MotherDuck',
  icon: <MotherDuckIcon />,
  link: 'https://docs.omni.co/connect-data/setup/motherduck',
}

const Postgres: IntegrationItemProps = {
  name: 'Postgres',
  icon: <PostgresIcon />,
  link: 'https://docs.omni.co/connect-data/setup/postgres/',
}

const MicrosoftSQLServer: IntegrationItemProps = {
  name: 'Microsoft SQL Server',
  icon: <MicrosoftSQLServerIcon />,
  link: 'https://docs.omni.co/connect-data/setup/microsoftsql/',
}

const Clickhouse: IntegrationItemProps = {
  name: 'Clickhouse',
  icon: <ClickhouseIcon />,
  link: 'https://docs.omni.co/connect-data/setup/clickhouse',
}

const Trino: IntegrationItemProps = {
  name: 'Trino',
  icon: <TrinoIcon />,
  link: 'https://trino.io/',
}

const Dbt: IntegrationItemProps = {
  name: 'dbt',
  icon: <DbtIcon />,
  link: 'https://docs.omni.co/integrations/dbt',
}

const MCPServer: IntegrationItemProps = {
  name: 'MCP Server',
  icon: <MCPServerIcon />,
  link: 'https://docs.omni.co/docs/ai/mcp',
}

const Git: IntegrationItemProps = {
  name: 'git',
  icon: <GitIcon />,
  link: 'https://docs.omni.co/docs/integrations/git',
}

export const integrationsList = [
  AmazonRedshift,
  Clickhouse,
  Databricks,
  Dbt,
  GoogleBigQuery,
  MicrosoftSQLServer,
  MotherDuck,
  MySQL,
  Postgres,
  Snowflake,
  Trino,
]

export const integrationsListCarousel = [
  { ...Snowflake, link: '/snowflake' },
  GoogleBigQuery,
  { ...Databricks, link: '/databricks' },
  { ...Dbt, link: '/dbt' },
  MCPServer,
  Git,
  AmazonRedshift,
  Postgres,
  Clickhouse,
  Trino,
  MySQL,
  MotherDuck,
  MicrosoftSQLServer,
]
